import React, { useState, useEffect } from "react";

const DOMAINS = [
  "Consulting & Strategy",
  "Legal & Compliance",
  "Finance & Taxation",
  "Funding & Investor Relations",
  "Digital Marketing & Promotions",
  "Technology & Product",
  "Operations & Supply Chain",
  "HR & Talent Acquisition",
  "PR & Media Relations",
  "International Trade & Import-Export",
  "MSME & Govt Liaison",
  "Startup & Innovation Cell",
  "Content Management",
  "Zumba & Fitness",
  "Mind Motivation & Life Coaching",
  "Real Estate & Infrastructure",
  "Manufacturing & Industrial Advisory",
  "Branding & Marketing Strategy",
  "Women Entrepreneurship Cell",
  "NRI / Global Bengali Desk",
  "Other",
];

const SHORT_MONTHS = [
  "Jan","Feb","Mar","Apr","May","Jun",
  "Jul","Aug","Sep","Oct","Nov","Dec",
];

function populateDays(month, year) {
  const total = new Date(year, month, 0).getDate();
  return Array.from({ length: total }, (_, i) => String(i + 1).padStart(2, "0"));
}

const metricCards = [
  {
    accent: "linear-gradient(90deg,#6366f1,#818cf8)",
    iconBg: "rgba(99,102,241,0.15)",
    iconColor: "#818cf8",
    icon: "fa-users",
    num: "25+",
    label: "Vetted Experts",
  },
  {
    accent: "linear-gradient(90deg,#14b8a6,#2dd4bf)",
    iconBg: "rgba(20,184,166,0.15)",
    iconColor: "#2dd4bf",
    icon: "fa-layer-group",
    num: "15+",
    label: "Startups Incubated",
  },
  {
    accent: "linear-gradient(90deg,#e879f9,#d946ef)",
    iconBg: "rgba(217,70,239,0.15)",
    iconColor: "#e879f9",
    icon: "fa-handshake",
    num: "100+",
    label: "Entrepreneurs Engaged",
  },
  {
    accent: "linear-gradient(90deg,#38bdf8,#0ea5e9)",
    iconBg: "rgba(14,165,233,0.15)",
    iconColor: "#38bdf8",
    icon: "fa-arrow-trend-up",
    num: "10+",
    label: "Startup Funding Processed",
  },
];

const CTA = () => {
  const today = new Date();

  const [showModal, setShowModal] = useState(false);
  const [booked, setBooked]       = useState(false);
  const [loading, setLoading]     = useState(false);
  const [toast, setToast]         = useState({ type: "", msg: "" });

  const [name,   setName]   = useState("");
  const [phone,  setPhone]  = useState("");
  const [email,  setEmail]  = useState("");
  const [domain, setDomain] = useState("");

  const [calDay,   setCalDay]   = useState(String(today.getDate()).padStart(2, "0"));
  const [calMonth, setCalMonth] = useState(String(today.getMonth() + 1));
  const [calYear,  setCalYear]  = useState(String(today.getFullYear()));
  const [days, setDays]         = useState([]);

  const [timeH, setTimeH] = useState("");
  const [timeM, setTimeM] = useState("");

  useEffect(() => {
    const newDays = populateDays(Number(calMonth), Number(calYear));
    setDays(newDays);
    if (!newDays.includes(calDay)) setCalDay(newDays[0]);
  }, [calMonth, calYear, calDay]);

  const yearOptions = Array.from({ length: 3 }, (_, i) => today.getFullYear() + i);
  const hourOptions = Array.from({ length: 24 }, (_, i) => String(i).padStart(2, "0"));

  const openModal = () => {
    setShowModal(true);
    setBooked(false);
    setToast({ type: "", msg: "" });
    setName(""); setPhone(""); setEmail(""); setDomain("");
    setCalDay(String(today.getDate()).padStart(2, "0"));
    setCalMonth(String(today.getMonth() + 1));
    setCalYear(String(today.getFullYear()));
    setTimeH(""); setTimeM("");
  };

  const closeModal = () => setShowModal(false);
  const showErr = (msg) => setToast({ type: "error", msg });
  const showOk  = (msg) => setToast({ type: "success", msg });

  const handleBook = async () => {
    setToast({ type: "", msg: "" });

    if (!name.trim())                              return showErr("Please enter your full name.");
    if (!phone.trim() || phone.trim().length < 10) return showErr("Please enter a valid phone number.");
    if (!email.trim() || !email.includes("@"))     return showErr("Please enter a valid email address.");
    if (!domain)                                   return showErr("Please select an expert domain.");
    if (!calDay || !calMonth || !calYear)          return showErr("Please select a complete date.");
    if (!timeH || !timeM)                          return showErr("Please select a time.");

    const dateStr = `${calDay}/${String(calMonth).padStart(2, "0")}/${calYear}`;
    const timeStr = `${timeH}:${timeM}`;

    setLoading(true);
    try {
      const res = await fetch("/api/booking", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          name: name.trim(),
          phone: phone.trim(),
          email: email.trim(),
          domain,
          dateStr,
          timeStr,
        }),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error || "Unknown error");
      setBooked(true);
      showOk(`Booking confirmed for ${dateStr} at ${timeStr} IST. A confirmation has been sent to your email!`);
    } catch (err) {
      console.error("Booking failed:", err);
      showErr("Could not send booking. Please try again.");
    }
    setLoading(false);
  };

  return (
    <>
      {/* Responsive styles */}
      <style>{`
        .ibh-cta-banner {
          display: flex;
          flex-direction: column;
          align-items: stretch;
          gap: 2rem;
          background: #0A0F1E;
          border-radius: 2rem;
          padding: clamp(1.5rem, 4vw, 3rem) clamp(1.25rem, 4vw, 3.5rem);
          position: relative;
          overflow: hidden;
        }
        @media (min-width: 768px) {
          .ibh-cta-banner {
            flex-direction: row;
            align-items: center;
          }
        }
      `}</style>

      {/* CTA Section */}
      <section className="py-20 sm:py-28" data-testid="cta-section">
        <div className="section">
          <div className="ibh-cta-banner">
            {/* Glow TL */}
            <div
              style={{
                position: "absolute", top: "-6rem", left: "-6rem",
                width: "24rem", height: "24rem", borderRadius: "50%",
                background: "radial-gradient(circle,rgba(99,102,241,0.18) 0%,transparent 70%)",
                pointerEvents: "none",
              }}
            />
            {/* Glow BR */}
            <div
              style={{
                position: "absolute", bottom: "-6rem", right: "18rem",
                width: "20rem", height: "20rem", borderRadius: "50%",
                background: "radial-gradient(circle,rgba(20,184,166,0.11) 0%,transparent 70%)",
                pointerEvents: "none",
              }}
            />

            {/* LEFT */}
            <div
              style={{
                flex: "1 1 0", minWidth: 0, display: "flex",
                flexDirection: "column", gap: "1.1rem",
                position: "relative", zIndex: 1,
              }}
            >
              {/* Badge */}
              <div
                style={{
                  display: "inline-flex", alignItems: "center", gap: "0.5rem",
                  background: "rgba(99,102,241,0.13)",
                  border: "1px solid rgba(99,102,241,0.28)",
                  borderRadius: "50px", padding: "6px 16px", width: "fit-content",
                }}
              >
                <div
                  style={{
                    width: 8, height: 8, borderRadius: "50%",
                    background: "#a78bfa", boxShadow: "0 0 7px #a78bfa99",
                  }}
                />
                <span
                  style={{
                    fontSize: "10.5px", fontWeight: 700,
                    letterSpacing: "0.13em", color: "#c4b5fd", textTransform: "uppercase",
                  }}
                >
                  Limited Slots This Month
                </span>
              </div>

              {/* Headline */}
              <h2
                style={{
                  fontSize: "clamp(2rem,3.5vw,2.6rem)",
                  fontWeight: 700, lineHeight: 1.1, color: "#fff", margin: 0,
                }}
              >
                Ready to{" "}
                <span
                  style={{
                    background: "linear-gradient(135deg,#6366f1 0%,#14b8a6 100%)",
                    WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent",
                    backgroundClip: "text",
                  }}
                >
                  Scale Your
                </span>
                <br />
                Business?
              </h2>

              {/* Body */}
              <p
                style={{
                  fontSize: "14.5px", color: "rgba(255,255,255,0.75)",
                  lineHeight: 1.68, maxWidth: 350, margin: 0,
                }}
              >
                Book a free 30-minute consultation and we'll map out your next
                3 quarters — across funding, ops, hiring, growth &amp; many more!
              </p>

              {/* Buttons */}
              <div style={{ display: "flex", gap: "0.75rem", flexWrap: "wrap", marginTop: "0.25rem" }}>
                <button
                  onClick={openModal}
                  data-testid="cta-book-consultation"
                  style={{
                    display: "inline-flex", alignItems: "center", gap: "0.6rem",
                    background: "#fff", border: "none",
                    borderRadius: "9999px", padding: "0.75rem 1.5rem",
                    color: "#0f172a", fontSize: "13.5px", fontWeight: 600,
                    cursor: "pointer", fontFamily: "inherit",
                    boxShadow: "0 4px 14px rgba(0,0,0,0.25)",
                  }}
                >
                  <i className="fa-solid fa-calendar-check"></i>
                  Book Consultation
                </button>
                <a
                  href="#membership"
                  data-testid="cta-view-plans"
                  style={{
                    display: "inline-flex", alignItems: "center", gap: "0.6rem",
                    background: "transparent",
                    border: "1.5px solid rgba(255,255,255,0.32)",
                    borderRadius: "9999px", padding: "0.75rem 1.5rem",
                    color: "#fff", fontSize: "13.5px", fontWeight: 500,
                    textDecoration: "none", fontFamily: "inherit",
                  }}
                >
                  View Plans →
                </a>
              </div>
            </div>

            {/* RIGHT */}
            <div
              style={{
                flex: "1 1 0", minWidth: 0, display: "flex",
                flexDirection: "column", gap: "0.75rem",
                position: "relative", zIndex: 1,
              }}
            >
              {/* Hero card */}
              <div
                style={{
                  background: "linear-gradient(145deg, #1a1f4e 0%, #141836 60%, #0f1228 100%)",
                  border: "1px solid rgba(99,102,241,0.4)",
                  borderRadius: "1rem", padding: "1.5rem 1.6rem",
                  position: "relative", overflow: "hidden",
                  boxShadow: "0 8px 32px rgba(10,10,30,0.6)",
                }}
              >
                <div
                  style={{
                    position: "absolute", top: "-2rem", right: "-2rem",
                    width: "12rem", height: "12rem", borderRadius: "50%",
                    background: "radial-gradient(circle, rgba(99,102,241,0.2) 0%, transparent 70%)",
                    pointerEvents: "none",
                  }}
                />
                <div
                  style={{
                    display: "flex", alignItems: "center",
                    justifyContent: "space-between", marginBottom: "1rem",
                    position: "relative", zIndex: 1,
                  }}
                >
                  <div style={{ display: "flex", alignItems: "center", gap: "0.55rem" }}>
                    <div
                      style={{
                        width: 28, height: 28, borderRadius: 7,
                        background: "rgba(99,102,241,0.25)",
                        display: "flex", alignItems: "center", justifyContent: "center",
                        fontSize: 13, color: "#a5b4fc", fontWeight: 700,
                      }}
                    >
                      ₹
                    </div>
                    <span
                      style={{
                        fontSize: "10px", fontWeight: 700, letterSpacing: "0.13em",
                        color: "rgba(255,255,255,0.5)", textTransform: "uppercase",
                      }}
                    >
                      Funds Raised
                    </span>
                  </div>
                  <div
                    style={{
                      background: "#2d2f6b",
                      border: "1px solid rgba(99,102,241,0.5)",
                      borderRadius: "0.45rem", padding: "4px 11px",
                      fontSize: "11px", fontWeight: 700,
                      color: "#a5b4fc", letterSpacing: "0.03em", whiteSpace: "nowrap",
                    }}
                  >
                    FY 26–27 Q1
                  </div>
                </div>
                <div
                  style={{
                    fontSize: "clamp(2.4rem,4.5vw,3.2rem)",
                    fontWeight: 800, color: "#fff", lineHeight: 1,
                    marginBottom: "0.5rem", letterSpacing: "-0.01em",
                    position: "relative", zIndex: 1,
                  }}
                >
                  ₹11.5 Cr+
                </div>
                <div
                  style={{
                    fontSize: "12.5px", color: "rgba(255,255,255,0.6)",
                    position: "relative", zIndex: 1,
                  }}
                >
                  Across portfolio companies
                </div>
              </div>

              {/* 2x2 metric cards */}
              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "0.75rem" }}>
                {metricCards.map((m) => (
                  <div
                    key={m.label}
                    style={{
                      background: "linear-gradient(145deg,rgba(20,26,52,0.97) 0%,rgba(13,17,38,0.99) 100%)",
                      border: "1px solid rgba(255,255,255,0.07)",
                      borderRadius: "16px",
                      padding: "1.1rem 1.25rem",
                      position: "relative", overflow: "hidden",
                    }}
                  >
                    <div
                      style={{
                        position: "absolute", top: 0, left: 0, right: 0,
                        height: 2, background: m.accent,
                      }}
                    />
                    <div
                      style={{
                        width: 30, height: 30, borderRadius: 8,
                        background: m.iconBg,
                        display: "flex", alignItems: "center", justifyContent: "center",
                        marginBottom: "0.75rem", fontSize: 13,
                      }}
                    >
                      <i className={`fa-solid ${m.icon}`} style={{ color: m.iconColor }}></i>
                    </div>
                    <div
                      style={{
                        fontSize: "1.5rem", fontWeight: 700,
                        color: "#fff", lineHeight: 1, marginBottom: 5,
                      }}
                    >
                      {m.num}
                    </div>
                    <div style={{ fontSize: "12px", color: "rgba(255,255,255,0.6)", lineHeight: 1.4 }}>
                      {m.label}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Booking Modal */}
      {showModal && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm p-4"
          onClick={(e) => { if (e.target === e.currentTarget) closeModal(); }}
        >
          <div
            className="bg-white rounded-2xl shadow-2xl w-full max-w-md relative max-h-[92vh] overflow-y-auto"
            style={{ animation: "ibhSlideUp 0.28s ease" }}
          >
            <style>{`
              @keyframes ibhSlideUp {
                from { opacity: 0; transform: translateY(18px); }
                to   { opacity: 1; transform: translateY(0); }
              }
              .ibh-field label {
                display: block;
                font-size: 11px;
                font-weight: 600;
                letter-spacing: 0.07em;
                text-transform: uppercase;
                color: #64748b;
                margin-bottom: 5px;
              }
              .ibh-field input,
              .ibh-field select {
                width: 100%;
                padding: 9px 12px;
                font-size: 14px;
                color: #0f172a;
                background: #fff;
                border: 1px solid #e2e8f0;
                border-radius: 10px;
                outline: none;
                transition: border-color 0.15s, box-shadow 0.15s;
                appearance: none;
                -webkit-appearance: none;
                font-family: inherit;
              }
              .ibh-field select {
                background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%2364748b' d='M6 8L1 3h10z'/%3E%3C/svg%3E");
                background-repeat: no-repeat;
                background-position: right 11px center;
                padding-right: 30px;
              }
              .ibh-field input:focus,
              .ibh-field select:focus {
                border-color: #185FA5;
                box-shadow: 0 0 0 3px rgba(24,95,165,0.12);
              }
              .ibh-field input::placeholder { color: #94a3b8; }
              .ibh-divider {
                display: flex; align-items: center; gap: 10px;
                font-size: 11px; font-weight: 600; letter-spacing: 0.07em;
                text-transform: uppercase; color: #94a3b8;
                margin: 1.1rem 0 0.85rem;
              }
              .ibh-divider::before, .ibh-divider::after {
                content: ''; flex: 1; height: 1px; background: #f1f5f9;
              }
            `}</style>

            {/* Modal Header */}
            <div className="flex items-start justify-between px-6 pt-5 pb-4 border-b border-slate-100">
              <div>
                <div className="flex items-center gap-2 mb-1">
                  <span style={{ width:8, height:8, borderRadius:"50%", background:"#f37c23", display:"inline-block" }}></span>
                  <span style={{ width:8, height:8, borderRadius:"50%", background:"#002a9b", display:"inline-block" }}></span>
                  <span style={{ width:8, height:8, borderRadius:"50%", background:"#00a000", display:"inline-block" }}></span>
                </div>
                <h3 className="text-lg font-bold text-slate-900">Book a Free Consultation</h3>
                <p className="text-slate-400 text-xs mt-0.5">Fill in your details — we'll confirm your slot shortly</p>
              </div>
              <button
                onClick={closeModal}
                className="w-8 h-8 flex items-center justify-center rounded-full hover:bg-slate-100 text-slate-400 hover:text-slate-600 transition flex-shrink-0 mt-1"
              >
                <i className="fa-solid fa-xmark"></i>
              </button>
            </div>

            <div className="px-6 py-5 space-y-3">
              <div className="ibh-field">
                <label htmlFor="ibh-name">Your full name</label>
                <input
                  id="ibh-name" type="text" placeholder="e.g. Ravi Kumar"
                  value={name} onChange={(e) => setName(e.target.value)} autoComplete="off"
                />
              </div>

              <div className="ibh-field">
                <label htmlFor="ibh-phone">Phone number</label>
                <input
                  id="ibh-phone" type="tel" placeholder="e.g. 9876543210"
                  value={phone} onChange={(e) => setPhone(e.target.value)} autoComplete="off"
                />
              </div>

              <div className="ibh-field">
                <label htmlFor="ibh-email">Email address</label>
                <input
                  id="ibh-email" type="email" placeholder="you@example.com"
                  value={email} onChange={(e) => setEmail(e.target.value)} autoComplete="off"
                />
              </div>

              <div className="ibh-field">
                <label htmlFor="ibh-domain">Expert domain required</label>
                <select id="ibh-domain" value={domain} onChange={(e) => setDomain(e.target.value)}>
                  <option value="">— Select a domain —</option>
                  {DOMAINS.map((d) => (
                    <option key={d} value={d}>{d}</option>
                  ))}
                </select>
              </div>

              <div className="ibh-divider">Schedule</div>

              <div className="ibh-field">
                <label>Date (DD / MM / YYYY)</label>
                <div style={{ display: "grid", gridTemplateColumns: "2fr 2fr 2.4fr", gap: 8 }}>
                  <select value={calDay} onChange={(e) => setCalDay(e.target.value)}>
                    <option value="">DD</option>
                    {days.map((d) => (
                      <option key={d} value={d}>{d}</option>
                    ))}
                  </select>
                  <select value={calMonth} onChange={(e) => setCalMonth(e.target.value)}>
                    {SHORT_MONTHS.map((m, i) => (
                      <option key={m} value={String(i + 1)}>{m}</option>
                    ))}
                  </select>
                  <select value={calYear} onChange={(e) => setCalYear(e.target.value)}>
                    {yearOptions.map((y) => (
                      <option key={y} value={String(y)}>{y}</option>
                    ))}
                  </select>
                </div>
              </div>

              <div className="ibh-field">
                <label>Time — 24-hour IST (HH : MM)</label>
                <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 8 }}>
                  <select value={timeH} onChange={(e) => setTimeH(e.target.value)}>
                    <option value="">HH</option>
                    {hourOptions.map((h) => (
                      <option key={h} value={h}>{h}</option>
                    ))}
                  </select>
                  <select value={timeM} onChange={(e) => setTimeM(e.target.value)}>
                    <option value="">MM</option>
                    <option value="00">00</option>
                    <option value="15">15</option>
                    <option value="30">30</option>
                    <option value="45">45</option>
                  </select>
                </div>
              </div>

              {toast.msg && (
                <div
                  style={{
                    padding: "10px 14px", borderRadius: 10, fontSize: 13,
                    fontWeight: 500, lineHeight: 1.5,
                    background: toast.type === "success" ? "#e9f7ef" : "#fdecea",
                    color: toast.type === "success" ? "#1a7a42" : "#b91c1c",
                    border: `1px solid ${toast.type === "success" ? "#a8dfc0" : "#f9b4b4"}`,
                  }}
                >
                  {toast.msg}
                </div>
              )}

              <button
                onClick={handleBook}
                disabled={loading}
                className="w-full py-3 rounded-full text-sm font-semibold transition"
                style={{
                  background: loading ? "#94a3b8" : "#0F2A5E",
                  color: "#fff",
                  cursor: loading ? "not-allowed" : "pointer",
                  display: "flex", alignItems: "center", justifyContent: "center", gap: 8,
                  boxShadow: loading ? "none" : "0 4px 14px rgba(15,42,94,0.25)",
                  marginTop: "0.5rem",
                }}
              >
                {loading ? (
                  <>
                    <span
                      style={{
                        width: 15, height: 15,
                        border: "2px solid rgba(255,255,255,0.3)",
                        borderTopColor: "#fff", borderRadius: "50%",
                        animation: "ibhSpin 0.7s linear infinite",
                        display: "inline-block",
                      }}
                    ></span>
                    Preparing booking…
                    <style>{`@keyframes ibhSpin { to { transform: rotate(360deg); } }`}</style>
                  </>
                ) : (
                  <>
                    <i className="fa-solid fa-calendar-check"></i>
                    Confirm Booking
                  </>
                )}
              </button>

              <p className="text-center text-xs text-slate-400 pb-1">
                Sent to indianbusinesshelpline@gmail.com
              </p>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default CTA;